<template>
    <div class="tw-bg-primary-100">
        <section class="tw-relative tw-h-[70vh] tw-w-full">
            <v-img
                src="@/assets/images/pitoes-panoramica.jpg"
                cover
                class="tw-h-full tw-w-full">
                <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/40">
                    <div class="tw-px-4 tw-text-center">
                        <span class="tw-mb-4 tw-block tw-text-sm tw-font-medium tw-uppercase tw-tracking-[0.3em] tw-text-primary">Trás-os-Montes</span>
                        <h1 class="tw-font-serif tw-text-5xl tw-text-white md:tw-text-7xl">Pitões das Júnias</h1>
                        <p class="tw-mx-auto tw-mt-6 tw-max-w-xl tw-text-lg tw-font-light tw-text-white/80">Onde o tempo abranda e as tradições ganham sabor.</p>
                    </div>
                </div>
            </v-img>
        </section>

        <section class="tw-mx-auto tw-max-w-7xl tw-px-6 tw-py-20">
            <div class="tw-grid tw-items-center tw-gap-16 md:tw-grid-cols-12">
                <div class="md:tw-col-span-7">
                    <h2 class="tw-font-serif tw-mb-8 tw-text-3xl tw-text-gray-800 md:tw-text-4xl">Uma Aldeia de Pedra e Lendas</h2>
                    <div class="tw-space-y-6 tw-text-lg tw-leading-relaxed tw-text-gray-600">
                        <p>
                            Situada a 1100 metros de altitude, no coração do Parque Nacional da Peneda-Gerês, Pitões das Júnias é uma das aldeias mais altas e isoladas de Portugal. Erguida em granito,
                            a sua história confunde-se com a do Mosteiro de Santa Maria das Júnias, que remonta ao século XII.
                        </p>
                        <p>
                            Aqui, a vida ainda segue o ritmo das estações e do gado. Entre as cascatas geladas e os trilhos de pastoreio, mantém-se viva a cultura do entreajuda e o respeito sagrado
                            pela terra. Visitar Pitões não é apenas uma viagem geográfica, é uma viagem ao Portugal autêntico.
                        </p>
                    </div>
                </div>
                <div class="tw-grid tw-grid-cols-2 tw-gap-4 md:tw-col-span-5">
                    <v-img
                        src="@/assets/images/mosteiro.jpg"
                        cover
                        class="tw-h-48 tw-rounded-lg" />
                    <v-img
                        src="@/assets/images/cascata.jpg"
                        cover
                        class="tw-mt-8 tw-h-48 tw-rounded-lg" />
                </div>
            </div>
        </section>

        <section class="tw-bg-primary-200 tw-py-12 md:tw-py-20">
            <div class="tw-mx-auto tw-max-w-7xl tw-px-6">
                <div class="tw-flex tw-flex-col-reverse tw-items-center tw-gap-10 md:tw-flex-row md:tw-gap-16">
                    <div class="md:tw-w-1/2">
                        <span class="tw-text-sm tw-font-medium tw-uppercase tw-tracking-widest tw-text-secondary">Desde 2004</span>
                        <h2 class="tw-font-serif tw-mb-8 tw-mt-2 tw-text-3xl tw-text-gray-800 md:tw-text-4xl">A Padaria Pitões</h2>
                        <div class="tw-space-y-6 tw-leading-relaxed tw-text-gray-700">
                            <p>
                                No centro da aldeia, a <strong>Padaria Pitões (Família Marinho)</strong> é mais do que um comércio; é um ponto de encontro. O fumo que sai da chaminé anuncia, todos os
                                dias, o pão cozido em forno a lenha, seguindo as receitas que passaram de geração em geração.
                            </p>
                            <p>
                                É aqui, entre o calor dos fornos e o aroma do pão quente, que o <strong>Atelier da Marina</strong> ganha vida. Combinamos a sabedoria artesanal da nossa família com a
                                delicadeza da pastelaria moderna, criando um contraste único entre o rústico e o sofisticado.
                            </p>
                            <p>
                                Augusto e Gracinda Marinho, os guardiões desta tradição, continuam a inspirar-nos diariamente. A sua dedicação à arte que nos ensinaram é o alicerce sobre o qual
                                construímos o nosso atelier.
                            </p>
                            <blockquote class="tw-my-8 tw-border-l-4 tw-border-secondary tw-pl-6 tw-italic tw-text-secondary tw-text-gray-600">
                                "Não há quem passe em Pitões e não se deixe levar pelo cheiro do nosso pão."
                            </blockquote>
                        </div>
                    </div>

                    <div class="tw-relative tw-w-full md:tw-w-1/2">
                        <v-img
                            src="@/assets/images/padaria.jpg"
                            cover
                            class="tw-rounded-lg tw-shadow-2xl"
                            :height="$vuetify.display.smAndDown ? '350' : '600'" />
                        <div class="tw-absolute -tw-bottom-6 -tw-right-6 tw-hidden tw-bg-secondary tw-p-8 tw-text-primary-100 md:tw-block">
                            <p class="tw-font-serif tw-text-2xl">Pão Quente</p>
                            <p class="tw-text-sm tw-opacity-80">Todos os dias às 11:30</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="tw-px-6 tw-py-20 tw-text-center">
            <h3 class="tw-font-serif tw-mb-6 tw-text-2xl">Estás de passagem pelo Gerês?</h3>
            <p class="tw-text-gray-500 tw-mx-auto tw-mb-10 tw-max-w-2xl">Vem sentir o aroma do pão acabado de cozer e descobrir as doçuras do nosso atelier. Estamos à tua espera na Rua do Outeiro.</p>
        </section>
    </div>
</template>
